import { render } from "./leftLevel.vue?vue&type=template&id=c5f80de0&scoped=true&ts=true"
import script from "./leftLevel.vue?vue&type=script&lang=ts"
export * from "./leftLevel.vue?vue&type=script&lang=ts"

import "./leftLevel.vue?vue&type=style&index=0&id=c5f80de0&lang=css"
import "./leftLevel.vue?vue&type=style&index=1&id=c5f80de0&lang=less&scoped=true"

import exportComponent from "E:\\bjft\\bjft-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f80de0"]])

export default __exports__